import React from 'react';
import { clsx } from 'clsx';
import { Dropdown } from './Listbox';

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <div>
      <div className="border-b border-gray-200">
        {/* Mobile Dropdown */}
        <div className="md:hidden px-4 py-4">
          <Dropdown
            size="large"
            options={tabs.map(tab => ({
              id: tab.id,
              text: tab.label
            }))}
            value={activeTab}
            onChange={(option) => onChange(option.id)}
          />
        </div>

        {/* Desktop Tab Navigation */}
        <nav className="hidden md:flex -mb-px px-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={clsx(
                'whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm mr-8 cursor-pointer',
                activeTab === tab.id
                  ? 'border-primary-base text-primary-base'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}